module.exports = __webpack_public_path__ + "static/media/cardio.03d1a882.jpg";